import styled from 'styled-components';
import PremiumSectionContainer from './PremiumSectionContainer';

export const ComplementaryInfoContainer = styled(PremiumSectionContainer)`
  background-color: var(--grey200);
`;
